import { render, staticRenderFns } from "./HeartlandVersionNumber.vue?vue&type=template&id=f7335fc2&"
import script from "./HeartlandVersionNumber.vue?vue&type=script&lang=ts&"
export * from "./HeartlandVersionNumber.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports